import {svgIconWrapper} from '../svg-icon-wrapper';

import ChevronLightRegularRightSvg from './chevron-light-regular-right-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChevronLightRegularRightSvg {...validProps} />;
}
SvgComponent.iconName = 'chevronLightRegularRight';

export const ChevronLightRegularRight = svgIconWrapper(SvgComponent);
